export const moviesActionTypes = {
  MOVIES__FETCHING__START: "MOVIES__FETCHING__START",
  MOVIE__FETCHING__SUCCESS: "MOVIE__FETCHING__SUCCESS",
  MOVIE__FETCHING__FAILED: "MOVIE__FETCHING__SUCCESS",
};
